// Backend business error codes for the MFA setup endpoints. Stable contract
// values shared with the talkdesk-id backend, duplicated here (not imported
// from either app) to keep this package independent of app source trees.
export const MFA_LOCAL_LOGIN_REQUIRED = '0070001'
export const MFA_RECOVERY_OTP_REQUIRED = '0070002'
export const MFA_MECHANISM_ALREADY_REGISTERED = '0070003'
export const MFA_INVALID_OTP = '0070004'
export const MFA_INVALID_REGISTRATION = '0070005'
export const MFA_PASSWORD_DOESNT_MATCH = '0070191'
export const GENERIC_SERVER_ERROR_CODE = 'GENERIC_SERVER_ERROR'
